import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 36, className = "", testId }) => (
  <motion.div
    data-testid={testId}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineVar = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: i * 0.1 } }),
};

export const MaskLines = ({ lines, className = "", onLoad = false, delay = 0 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
    transition={{ delayChildren: delay }}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span className="block" variants={lineVar} custom={i + delay * 10}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
